'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixStepButton = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FixStepButton, _React$PureComponent);

    function FixStepButton() {
        (0, _classCallCheck3.default)(this, FixStepButton);
        return (0, _possibleConstructorReturn3.default)(this, (FixStepButton.__proto__ || (0, _getPrototypeOf2.default)(FixStepButton)).apply(this, arguments));
    }

    (0, _createClass3.default)(FixStepButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                text = _props.text,
                onClick = _props.onClick;

            return _react2.default.createElement(
                'div',
                { className: 'cart-s__bot' },
                _react2.default.createElement(
                    'a',
                    { className: 'btn btn--white btn--sm', onClick: onClick },
                    _react2.default.createElement('i', { className: 'icon--pen' }),
                    text
                )
            );
        }
    }]);
    return FixStepButton;
}(_react2.default.PureComponent), _class.propTypes = {
    text: _propTypes2.default.string.isRequired,
    onClick: _propTypes2.default.func.isRequired
}, _temp);
exports.default = FixStepButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/FixStepButton.js
// module id = 746
// module chunks = 0